import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/news/[slug]/NewsDetailClient.tsx");
